import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, Mail } from 'lucide-react';

export default function ThankYou() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-auto text-center p-8 bg-white rounded-lg shadow-md border">
        <div className="mb-8">
          <div className="h-24 w-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          <h1 className="text-3xl font-bold mb-4">Thank You!</h1>
          <p className="text-gray-600 mb-8">
            We've received your message and a confirmation has been sent to your email address. 
            Our team will get back to you as soon as possible.
          </p>
        </div>
        
        <div className="bg-blue-50 p-4 rounded-lg mb-6 flex items-start">
          <Mail className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
          <p className="text-sm text-blue-700 text-left">
            <strong>Check your inbox</strong> for a confirmation email with a copy of your message. 
            If you don't see it, please check your spam or promotions folder.
          </p>
        </div>
        
        <div className="space-y-3">
          <Button asChild variant="default" className="w-full">
            <Link to="/">Return Home</Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to="/writer">Try our Writer</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}